/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Box, Flex, Text, Link } from 'rebass/styled-components';
import { Logo, ProfilePicture } from '@getro/rombo';
import { FindemApplicationContainer } from 'components/organisms/jobsDataTable/components/FindemApplicationContainer';
import { HowItWorksModal } from './components/HowItWorksModal';
import { useSharedJobsCalibration } from './hooks/useSharedJobsCalibration';

const SharedJobsCalibration = () => {
  const { isLoading, error, job, showHowItWorksModal, setShowHowItWorksModal } = useSharedJobsCalibration();

  return (
    <Box>
      {!isLoading && (
        <Box
          px="16px"
          py="16px"
          sx={{
            borderBottom: '1px solid',
            borderColor: 'border.subtle',
          }}
        >
          <Flex
            flexDirection="column"
            sx={{
              gap: '8px',
            }}
          >
            <Flex
              justifyContent="space-between"
              alignItems="center"
              sx={{
                gap: '16px',
              }}
            >
              <Flex sx={{ gap: '16px', alignItems: 'center', flex: 1 }}>
                {job?.organization && (
                  <>
                    <ProfilePicture
                      variant="square"
                      name={job.organization.name}
                      imageUrl={job.organization.logoUrl}
                      width="40px"
                      height="40px"
                      sx={{ flexShrink: 0 }}
                    />
                    <Text fontSize="18px" fontWeight="600" color="text.dark" lineHeight="1.4">
                      {job.organization.name}
                    </Text>
                  </>
                )}
              </Flex>

              {/* Right side: Getro logo */}
              <Flex alignItems="center" sx={{ flexShrink: 0 }}>
                <Link href="https://www.getro.com" target="_blank" rel="noopener noreferrer">
                  <Logo color="primary" width="96px" />
                </Link>
              </Flex>
            </Flex>

            {/* Description text */}
            {job?.organization && job?.title && (
              <Text fontSize="14px" color="text.main" lineHeight="1.4">
                <Text as="span">{job.organization.name} is helping you get the best candidates for your </Text>
                <Text as="span" fontWeight="600">
                  {job.title}
                </Text>
                {job.organization.name && (
                  <>
                    <Text as="span"> at </Text>
                    <Text as="span" fontWeight="600">
                      {job.organization.name}
                    </Text>
                  </>
                )}
                <Text as="span"> role with </Text>
                <Text as="span" fontWeight="600">
                  Getro&apos;s AI Agent
                </Text>
                <Text as="span">. </Text>
                <Text
                  as="span"
                  onClick={() => setShowHowItWorksModal(true)}
                  sx={{
                    textDecoration: 'underline',
                    color: 'text.main',
                    cursor: 'pointer',
                    '&:hover': {
                      color: 'purple.500',
                    },
                  }}
                >
                  Learn more
                </Text>
                <Text as="span">.</Text>
              </Text>
            )}
          </Flex>
        </Box>
      )}
      <Box
        flex="1"
        sx={{
          position: 'relative',
          overflow: 'hidden',
          height: 'calc(100vh - 120px)',
          iframe: { maxWidth: '752px', height: '100%' },
        }}
      >
        <FindemApplicationContainer
          hideHeader
          isLoading={isLoading}
          error={error}
          title="Calibration Agent"
          view="shared-calibration"
        />
      </Box>
      {!isLoading && !error && showHowItWorksModal && (
        <HowItWorksModal
          isOpen={showHowItWorksModal}
          onClose={() => setShowHowItWorksModal(false)}
          organizationName={job?.organization?.name}
        />
      )}
    </Box>
  );
};

export default SharedJobsCalibration;
